import './CoordinateIndicator.css';

export function CoordinateIndicator({
  mode,
  visible = true,
  className = '',
}: {
  mode: '2d' | '3d';
  visible?: boolean;
  className?: string;
}) {
  if (!visible) return null;
  return (
    <div className={`coordinate-indicator ${className}`.trim()} aria-label={`${mode === '3d' ? 'X Y Z' : 'X Y'} coordinate axes`}>
      <svg viewBox="0 0 72 72" role="img" aria-hidden="true">
        <circle cx="18" cy="54" r="2.5" className="coordinate-indicator-origin" />
        <line x1="18" y1="54" x2="58" y2="54" className="coordinate-indicator-axis coordinate-indicator-x" />
        <path d="M58 54 L51 50 M58 54 L51 58" className="coordinate-indicator-axis coordinate-indicator-x" />
        <text x="63" y="57" className="coordinate-indicator-label coordinate-indicator-x-label">X</text>
        <line x1="18" y1="54" x2="18" y2="14" className="coordinate-indicator-axis coordinate-indicator-y" />
        <path d="M18 14 L14 21 M18 14 L22 21" className="coordinate-indicator-axis coordinate-indicator-y" />
        <text x="14" y="10" className="coordinate-indicator-label coordinate-indicator-y-label">Y</text>
        {mode === '3d' && (
          <>
            <line x1="18" y1="54" x2="45" y2="28" className="coordinate-indicator-axis coordinate-indicator-z" />
            <path d="M45 28 L37 30 M45 28 L43 36" className="coordinate-indicator-axis coordinate-indicator-z" />
            <text x="49" y="26" className="coordinate-indicator-label coordinate-indicator-z-label">Z</text>
          </>
        )}
      </svg>
    </div>
  );
}
